"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToSlug = void 0;
const stringToSlug = (str) => {
    str = str.replace(/&/g, (_match, offset, original) => {
        const before = original[offset - 1] || '';
        const after = original[offset + 1] || '';
        const needsSpaceBefore = before && !before.match(/\s/);
        const needsSpaceAfter = after && !after.match(/\s/);
        return `${needsSpaceBefore ? ' ' : ''}e${needsSpaceAfter ? ' ' : ''}`;
    });
    let slug = str.trim().toLowerCase();
    const from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    const to = "aaaaeeeeiiiioooouuuunc------";
    for (let i = 0, l = from.length; i < l; i++) {
        slug = slug.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }
    slug = slug.replace(/[^a-z0-9 -]/g, '');
    slug = slug.replace(/\s+/g, '-');
    slug = slug.replace(/-+/g, '-');
    return slug;
};
exports.stringToSlug = stringToSlug;
//# sourceMappingURL=slug.js.map